import React from "react"
import { CalendarIcon, DollarIcon, FrequencyIcon, TimeIcon } from "../../../../components/Icons/Icons"
import { PAYMENT_SCHEDULE } from "../../../../config/consts"
import { calculateMonthlyPaymentAmount, calculateTotalAmount } from "../helper"
import { resolveSavings } from '../../../../components/CreditReports/feeDisplay'

export const ReviewPlanDetails = ({ paymentSchedule, programPlan }) => {
  const paymentDate = typeof paymentSchedule?.cycleStartDate === 'string' ? paymentSchedule?.cycleStartDate?.substring(0, 10) : paymentSchedule?.cycleStartDate?.format("MM-DD-YYYY")
  const frequency = programPlan?.frequency || paymentSchedule?.frequency || 'monthly'
  const frequencyOptions = frequency

  const savedSchedule = Array.isArray(paymentSchedule?.tableData) ? paymentSchedule.tableData : null
  const hasSavedSchedule = savedSchedule && savedSchedule.length > 0

  const numberOfPayments = hasSavedSchedule ? savedSchedule.length : programPlan?.plan

  let paymentOptions
  let programCost
  if (hasSavedSchedule) {
    programCost = savedSchedule.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0)
    paymentOptions = (Number(savedSchedule[0]?.amount) || 0).toFixed(2)
  } else {
    paymentOptions = calculateMonthlyPaymentAmount({
      accountBalance: programPlan?.amount,
      programPlan,
      frequency,
      startDate: paymentSchedule?.cycleStartDate,
      secondStartDate: paymentSchedule?.secondDate,
    })?.toFixed(2) || 0
    programCost = calculateTotalAmount({
      accountBalance: programPlan?.amount,
      programPlan,
      frequency,
      startDate: paymentSchedule?.cycleStartDate,
      secondStartDate: paymentSchedule?.secondDate,
    })
  }
  // Floored at zero: a zero-balance client has no debt to settle, and a negative saving is not
  // a thing anyone can act on.
  const savings = resolveSavings({ enrolledDebt: programPlan?.amount, programCost })

  const planDetails = [
    {
      icon: <CalendarIcon />,
      label: "Payment start date:",
      value: paymentDate,
    },
    {
      icon: <DollarIcon />,
      label: "Payment:",
      value: `$${paymentOptions}`,
    },
    {
      icon: <FrequencyIcon />,
      label: "Frequency:",
      value: PAYMENT_SCHEDULE.find((e) => e.value === frequencyOptions)?.label || "-",
    },
    {
      icon: <TimeIcon />,
      label: "Number of Payments:",
      value: `${numberOfPayments} Payments`,
    },
    {
      icon: <DollarIcon />,
      label: "Savings:",
      value: `$${savings?.toFixed(2)}`,
    },
  ]

  return (
    <>
      <div className="bg-surface border border-divider shadow-lg rounded-2xl w-full max-w-[798px] mt-6">
        <div className="font-bold text-xl-20 pt-[24px] pl-[48px] pb-[16px]">
          Review Plan Details
        </div>
        <div className="border-b border-divider mx-6" />
        {planDetails?.map((detail, index) => (
          <div key={index} className="flex justify-between px-12 my-6">
            <div className="flex gap-[12px]">
              <div>
                {detail.icon}
              </div>
              <div className="font-normal text-md text-text-secondary">
                {detail?.label}
              </div>
            </div>
            <div className="font-bold text-[12px] text-text-primary">
              {detail?.value}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 mb-6 mr-6 flex justify-end space-x-4">
        {/*<Button*/}
        {/*  width="min-w-[156px]"*/}
        {/*  onClick={() => {*/}
        {/*    setSelectedTab("budget-calculator")*/}
        {/*  }}*/}
        {/*>*/}
        {/*  Save & proceed*/}
        {/*</Button>*/}
      </div>
    </>
  )
}